module.exports = __webpack_public_path__ + "img/p2.9c22eca8.png";